export const isVersionAtLeast = (
  version: string | undefined,
  minimum: string
): boolean => {
  if (!version || !/^\d+(\.\d+){0,3}$/.test(version)) return false;

  const versionSegments = version.split(".").map(Number);
  const minimumSegments = minimum.split(".").map(Number);
  const segmentCount = Math.max(
    versionSegments.length,
    minimumSegments.length
  );
  for (let index = 0; index < segmentCount; index++) {
    const versionSegment = versionSegments[index] ?? 0;
    const minimumSegment = minimumSegments[index] ?? 0;
    if (versionSegment !== minimumSegment)
      return versionSegment > minimumSegment;
  }
  return true;
};
